import React, { useEffect } from 'react'
import styles from './style.module.scss'
import { Redirect, useHistory, useLocation, useParams } from 'react-router'
import { SectionWrapper } from '@Root/HOCs'
import { getDataOptionsFromLocalStorage } from '@Root/helpers'
import { EditAccreditationAim } from './Edit'
import { CreateAccreditationAim } from './Create'
import { useSelector } from 'react-redux'
import { engagementSelectors } from '@Store/studies'
import { useDispatch } from 'react-redux'
import { modalActions } from '@Store/modal'
import { fieldTooltipManagerActions } from '@Store/fieldTooltipManager'

export const AccreditationAimPage = () => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const engagement = useSelector(engagementSelectors.engagement)
  const engagementPermissions = useSelector(engagementSelectors.permissions)
  const canBeCreated = engagement.can_be_created_student_accreditation_aim
  const pathname = location.pathname
  const isNew = pathname.includes('new')
  const { id: engagementId, studentId: contactId } = useParams()
  const accreditationAimId = pathname.split('/')[7]

  const DEFAULT_URL = `/home/studies/engagements/${contactId}/${engagementId}/student-accreditation-aim`

  useEffect(() => {
    getDataOptionsFromLocalStorage(['accreditation_aim'])
    dispatch(fieldTooltipManagerActions.getDescriptions({ entity: 'studies', entity_type: 'engagement_accreditation_aim' }))
  }, [])

  const onOpenDescriptionModal = (description, title) => {
    new Promise((resolve, reject) => {
      dispatch(
        modalActions.showModal('NotificationModal', {
          text: description,
          clickRejectButtonHandler: reject,
          clickResolveButtonHandler: resolve,
          title,
        })
      )
    }).finally(() => dispatch(modalActions.hideModal()))
  }

  if (!accreditationAimId) history.push(DEFAULT_URL)

  if (!canBeCreated && accreditationAimId === 'new' && engagement.id) return <Redirect to={DEFAULT_URL} />

  if (accreditationAimId !== 'new' && engagementPermissions.tabs && !engagementPermissions.tabs.student_accreditation_aim) return <Redirect to={DEFAULT_URL} />
  return (
    <SectionWrapper hasBackButton backButtonText={'Engagement Details'} clickBackButtonHandler={() => history.push(DEFAULT_URL)} activeName>
      <div className={styles.sections}>
        {isNew ? (
          <CreateAccreditationAim parentURL={DEFAULT_URL} onOpenDescriptionModal={onOpenDescriptionModal} />
        ) : (
          <EditAccreditationAim parentURL={DEFAULT_URL} onOpenDescriptionModal={onOpenDescriptionModal} />
        )}
      </div>
    </SectionWrapper>
  )
}
